function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 1.75,
  y: 4.75,
  width: 20.5,
  height: 14.5,
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 5L12 14.5L22.5 5",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 19.5L15 12",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2 19.5L9.5 12",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgMail = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Mail.8a147868.svg";
export { ForwardRef as ReactComponent };